import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './ActivityIndicator.css'

// it's spinkit
export const ActivityIndicator = () =>
  (
    <div styleName="sk-fading-circle">
      <div styleName="sk-circle" />
      <div styleName="sk-circle2 sk-circle" />
      <div styleName="sk-circle3 sk-circle" />
      <div styleName="sk-circle4 sk-circle" />
      <div styleName="sk-circle5 sk-circle" />
      <div styleName="sk-circle6 sk-circle" />
      <div styleName="sk-circle7 sk-circle" />
      <div styleName="sk-circle8 sk-circle" />
      <div styleName="sk-circle9 sk-circle" />
      <div styleName="sk-circle10 sk-circle" />
      <div styleName="sk-circle11 sk-circle" />
      <div styleName="sk-circle12 sk-circle" />
    </div>
  )

export default CSSModules(ActivityIndicator, styles, { allowMultiple: true  })



// WEBPACK FOOTER //
// ./src/components/ActivityIndicator/ActivityIndicator.js